export const isProdEnv = window.location.hostname === 'auth.olimpwarehousing.com'
